import {Box, LinearProgress} from "@mui/material";
import Typography from "@mui/material/Typography";

const LinearProgressWIthLabel = (props) => {
    const progressLabel = props.label ?? `${Math.round(props.value)}%`;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography
                    variant="body2"
                    sx={{ color: 'text.secondary' }}
                >{progressLabel}</Typography>
            </Box>
        </Box>
    );
};

export default LinearProgressWIthLabel;
